var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { addCommasWithoutEffectingDecimals, inWordsWithDecimal, } from "@domains/utils/numberMethods";
import actions from "@redux/feature/Markets/NCD/actions/TransactionJourneyActions";
import { useEffect, useMemo, useCallback } from "react";
import { useSelector } from "react-redux";
import useDirtyPriceDetails from "./useDirtyPriceDetails";
import useValidateDirtyPrice from "./useValidateDirtyPrice";
import useValidateQuantity from "./useValidateQuantity";
import { debounce } from "underscore";
import { EBuySellFlag } from "@domains/features/Markets/OTC/entities/CashFlow";
import * as URLConfig from "@frameworks/salesjourney/config/domain";
export var useBodyLayoutHandler = function (transactionDetails) {
    var cActions = new actions();
    var selectedClientDetails = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }).selectedClientDetails;
    var watchListRequestPayload = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }).watchListRequestPayload;
    var _a = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }), transactionJourney = _a.transactionJourney, dirtyPriceDetails = _a.dirtyPriceDetails, transactionId = _a.transactionId, draftOrderDetails = _a.draftOrderDetails;
    var _b = useValidateQuantity(), errorData = _b.errorData, fetchQuantity = _b.fetchQuantity;
    var _c = useValidateDirtyPrice(), dirtyPriceError = _c.errorData, fetchDirtyPrice = _c.fetchDirtyPrice;
    var _d = useDirtyPriceDetails();
    var summaryData = useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var data = dirtyPriceDetails === null || dirtyPriceDetails === void 0 ? void 0 : dirtyPriceDetails.data;
        return [
            {
                label: "Clean Price",
                value: "\u20B9".concat((_a = addCommasWithoutEffectingDecimals(Number(data === null || data === void 0 ? void 0 : data.clean_price).toFixed(2))) !== null && _a !== void 0 ? _a : "-"),
                info: true,
                toolTipText: "The bond's price excluding any accrued interest. It reflects the actual market value.",
                isSell: true,
                isBuy: false,
            },
            {
                label: "Accrued Interest",
                value: (_b = data === null || data === void 0 ? void 0 : data.accrued_interest) !== null && _b !== void 0 ? _b : "-",
                info: true,
                toolTipText: "The interest accumulated since the last coupon payment, added to the bond price.",
                isSell: true,
                isBuy: false,
            },
            {
                label: "Total Revenue",
                value: "\u20B9".concat((_c = addCommasWithoutEffectingDecimals(Number(data === null || data === void 0 ? void 0 : data.revenue).toFixed(2))) !== null && _c !== void 0 ? _c : "-"),
                info: false,
                subText: String((_d = data === null || data === void 0 ? void 0 : data.revenue) !== null && _d !== void 0 ? _d : "-"),
                isSell: true,
                isBuy: false,
                inWords: inWordsWithDecimal(Number((_e = String(data === null || data === void 0 ? void 0 : data.revenue)) === null || _e === void 0 ? void 0 : _e.split(",").join(""))),
            },
            {
                label: "Amount",
                value: "\u20B9".concat((_f = addCommasWithoutEffectingDecimals(Number(data === null || data === void 0 ? void 0 : data.amount).toFixed(2))) !== null && _f !== void 0 ? _f : "-"),
                info: false,
                subText: String((_g = data === null || data === void 0 ? void 0 : data.amount) !== null && _g !== void 0 ? _g : "-"),
                isSell: true,
                isBuy: false,
                inWords: inWordsWithDecimal(Number((_h = String(data === null || data === void 0 ? void 0 : data.amount)) === null || _h === void 0 ? void 0 : _h.split(",").join(""))),
            },
            {
                label: "TDS (Applicable at 0.1%)",
                value: "\u20B9".concat((_j = addCommasWithoutEffectingDecimals(Number(data === null || data === void 0 ? void 0 : data.tds).toFixed(2))) !== null && _j !== void 0 ? _j : "0"),
                info: false,
                subText: String((_k = data === null || data === void 0 ? void 0 : data.tds) !== null && _k !== void 0 ? _k : "-"),
                isSell: false,
                isBuy: watchListRequestPayload.buysellflg === EBuySellFlag.BUY
                    ? true
                    : false,
                inWords: inWordsWithDecimal(Number((_l = String(data === null || data === void 0 ? void 0 : data.tds)) === null || _l === void 0 ? void 0 : _l.split(",").join(""))),
            },
        ];
    }, [dirtyPriceDetails]);
    var isValidQuantity = useMemo(function () { var _a, _b, _c; return ((_c = (_b = (_a = errorData === null || errorData === void 0 ? void 0 : errorData.error) === null || _a === void 0 ? void 0 : _a.errorParams) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.m_status) === "FAILURE"; }, [errorData, transactionDetails]);
    var errorMessageQuantity = useMemo(function () {
        var _a, _b, _c;
        if (isValidQuantity) {
            return (_c = (_b = (_a = errorData === null || errorData === void 0 ? void 0 : errorData.error) === null || _a === void 0 ? void 0 : _a.errorParams) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.m_message;
        }
        return "";
    }, [isValidQuantity, errorData]);
    var invalid = useMemo(function () { var _a, _b, _c; return ((_c = (_b = (_a = dirtyPriceError === null || dirtyPriceError === void 0 ? void 0 : dirtyPriceError.error) === null || _a === void 0 ? void 0 : _a.errorParams) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.m_status) === "FAILURE"; }, [dirtyPriceError]);
    var errorMessageDirtyPrice = useMemo(function () {
        var _a, _b, _c;
        if (invalid) {
            return (_c = (_b = (_a = dirtyPriceError === null || dirtyPriceError === void 0 ? void 0 : dirtyPriceError.error) === null || _a === void 0 ? void 0 : _a.errorParams) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.m_message;
        }
        return "";
    }, [invalid, transactionDetails]);
    var debouncedFetchDirtyPrice = useMemo(function () {
        return debounce(function (val) {
            fetchDirtyPrice(String(val));
        }, 500);
    }, []);
    var handleDirtyPriceChange = function (event) {
        var _a;
        if (((_a = event.target) === null || _a === void 0 ? void 0 : _a.value.length) <= 10) {
            var value = event.target.value;
            var numericValue = value;
            cActions.updateTransactionData(__assign(__assign({}, transactionJourney), { dirtyPrice: Number(numericValue) === 0 ? "" : numericValue }));
            debouncedFetchDirtyPrice(Number(numericValue));
            cActions.updateValidSetUpFess(false);
        }
    };
    var debouncedFetchQuantity = useMemo(function () {
        return debounce(function (val) {
            fetchQuantity(val);
        }, 500);
    }, []);
    var handleQuantityChange = function (event) {
        var _a;
        if (((_a = event.target) === null || _a === void 0 ? void 0 : _a.value.length) <= 8) {
            var numericValue = Number(event.target.value);
            cActions.updateTransactionData(__assign(__assign({}, transactionJourney), { quantity: numericValue === 0 ? "" : numericValue }));
            debouncedFetchQuantity(numericValue);
            cActions.updateValidSetUpFess(false);
        }
    };
    var handleNavigate = useCallback(function () {
        localStorage.setItem("client360SelectedClient", JSON.stringify(selectedClientDetails));
        var path = "".concat(URLConfig.config.applicationRoot, "clientdetails/overview?link=").concat(selectedClientDetails.isPartner ? "profile" : "overview");
        window.open(path, "_BLANK");
    }, [selectedClientDetails]);
    useEffect(function () {
        if (draftOrderDetails && Object.keys(draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data).length > 0)
            return;
        cActions.updateTransactionData(__assign(__assign({}, transactionJourney), { dirtyPrice: Number(transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.dirty_price) === 0
                ? ""
                : Number(transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.dirty_price) }));
    }, []);
    var onClickEdit = function (e) {
        if (transactionId <= 0) {
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            cActions.updateClientDetails(null);
            cActions.isinClientDetails({
                requestid: "",
                success: false,
                message: "",
                statuscode: "",
                errors: "",
                data: null,
            });
        }
    };
    return {
        summaryData: summaryData,
        isValidQuantity: isValidQuantity,
        errorMessageQuantity: errorMessageQuantity,
        invalid: invalid,
        handleDirtyPriceChange: handleDirtyPriceChange,
        handleQuantityChange: handleQuantityChange,
        handleNavigate: handleNavigate,
        selectedClientDetails: selectedClientDetails,
        transactionJourney: transactionJourney,
        cActions: cActions,
        onClickEdit: onClickEdit,
        errorMessageDirtyPrice: errorMessageDirtyPrice,
    };
};
